module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gS2K1"))).then(() => parcelRequire('d0iPb'));